import { ContentTexts } from './types';

// English site texts — translated from de.ts; keep the two files structurally
// identical when copy changes.

// ----------------------------------------------------------------------

const en: ContentTexts = {
  hero: {
    subTitle: 'Developing organizations. Moving people. Scaling impact.',
    titleLines: ['Driving', 'Development'],
    subText:
      'As a partner for consulting and training, we support companies in achieving effective development with a clear focus on implementation.',
  },

  ansatz: {
    subTitle: '',
    titleText: 'From Evidence to Excellence',
    subText:
      'Our approach combines scientifically grounded insights with rigorous practical applicability. We develop evidence-based programs that translate proven methods into scalable solutions for companies. Depending on the project, selected external specialists complement our FPV core team with specific expertise.',
  },

  leistungen: {
    'strategy-consulting': {
      subTitle: 'Strategies that work',
      titleText: 'Strategy Consulting',
      subText:
        'We support companies in developing and sharpening their strategic direction and in solving complex business challenges. Together we develop strategies that are scientifically grounded, practical, and tailored to the individual challenges of your company. Our commitment does not end with the strategy: we accompany implementation, build acceptance within the organization, and make sure good concepts turn into measurable results.',
    },
    'training-workshops': {
      subTitle: 'Trainings that change behavior',
      titleText: 'Training & Workshops',
      subText:
        'The success of a training is not decided in the seminar room, but in its application in everyday work. That is why we develop training concepts based on scientific insights into how people learn, how motivation emerges, and how lasting transfer succeeds. We are convinced that people do not change their behavior through information alone, but through experiences, reflection, and immediate application. That is why we rely on activating learning formats that combine evidence-based content with hands-on exercises, real case examples, and a rigorous focus on practice. Every training is individually tailored to the target group, prior knowledge, and company context — so transfer begins during the training itself. Our ambition is that participants leave the room not just with new knowledge, but with concrete competencies and solutions they can apply immediately in their day-to-day work.',
    },
    keynotes: {
      subTitle: 'Impulses with substance',
      titleText: 'Keynotes',
      subText:
        'Our keynotes combine scientifically grounded insights with emotional impulses and concrete recommendations for action. We do not just inspire new thinking — we create clarity, motivation, and concrete approaches for implementation. With hands-on examples and clear takeaways, participants leave every keynote with knowledge they can apply directly in their day-to-day work.',
    },
    'diy-workshop': {
      subTitle: 'Development that scales',
      titleText: 'DIY Workshop',
      subText:
        'In organizational development, scalability and effectiveness are often at odds. The more individual and interactive a development format is, the harder it is to roll out company-wide. Standardized learning formats reach many people but frequently fall short of the desired behavioral change and transfer into everyday work. With our DIY Workshop, we at FPV have developed a scientifically grounded organizational development format for exactly this tension. Based on our own research and experimentally validated, the format combines standardized video-based knowledge transfer with locally facilitated team workshops. The result: development programs that are effective, practical, and scalable across the entire company. In a recent case study in a production context, more than 1,500 leaders were successfully developed with a single DIY Workshop — entirely without external trainers.',
    },
    coaching: {
      subTitle: 'Unlocking potential',
      titleText: 'Coaching',
      subText:
        'Our coaching is based on validated psychological models and diagnostic instruments, such as the Big Five personality dimensions. Instead of relying on intuition alone, we build on sound analysis: we make individual strengths, development areas, and behavioral patterns visible and work on them deliberately. The result is a coaching process that does not just reflect but measurably develops. Whether leaders, teams, or individuals: we accompany people in recognizing their potential and unfolding it effectively.',
    },
    'data-analytics': {
      subTitle: 'From data to decisions',
      titleText: 'Data Analytics',
      subText:
        'Whether strategy development, training, or coaching: effective measures are built on reliable data. We analyze company and organizational data with scientific precision, identify patterns and potential, and derive concrete recommendations for action. This makes decisions well-founded and impact measurable.',
    },
    'assessment-center': {
      subTitle: 'Recognizing aptitude, shaping development',
      titleText: 'Assessment Center',
      subText:
        'Most assessment centers answer one question: Is a person suitable? We go one step further and additionally answer the decisive question: How does this person continue to develop successfully? Our assessment centers combine scientifically grounded diagnostics with individual people development. Using validated psychological instruments, structured interviews, simulations, case studies, and psychometric diagnostics, we create an objective basis for personnel decisions. The outcome: individual development plans, psychologically grounded feedback conversations, and concrete development measures instead of standardized result reports. Beyond that, we build company-specific assessment systems — from defining success-critical competencies and behavioral anchors to assessor handbooks, trainings, and scalable rollout concepts. This creates solutions that combine selection, development, and organizational scaling in one integrated system.',
    },
  },

  ui: {
    navAnsatz: 'Our Approach',
    navLeistungen: 'Services',
    navTeam: 'Team',
    contact: 'Contact',
    scrollHint: 'Scroll',
    nextHint: 'next',
    startLabel: 'Start',
    leistungenHeading: 'Services',
    leistungenTitle: 'What we do',
    teamEyebrow: 'Team',
    teamTitle: 'Your points of contact',
    teamIntro:
      'Our team includes additional experts who are flexibly involved in projects depending on their nature and topic. On every project, the partners remain the single point of contact for the client throughout.',
    teamCta: 'Get in touch →',
    footerRights: '© 2026 FPV Beratung & Training. All rights reserved.',
  },
};

export default en;
